<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" header="Detalle de tarea" [style]="{ width: '640px' }" (onHide)="close()">
  <div class="modal-loading" *ngIf="loading$ | async">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" ariaLabel="Cargando"></p-progressSpinner>
    <span>Cargando tarea…</span>
  </div>

  <div *ngIf="(task$ | async) as task" class="task-detail">
    <div class="info-card">
      <div class="card-header">
        <i class="fa-solid fa-list-check text-blue-600"></i>
        <h3>{{ task.title }}</h3>
        <p-tag [value]="task.state" [severity]="stateSeverity(task.state)"></p-tag>
      </div>
      <div class="card-content">
        <div class="field field-flex">
          <label for="state">Cambiar estado:</label>
          <div class="state-row">
            <p-dropdown inputId="state" [options]="stateOptions" [(ngModel)]="newState" optionLabel="label" optionValue="value" placeholder="Nuevo estado" [style]="{ flex: '1' }"></p-dropdown>
            <button pButton type="button" label="Aplicar" class="p-button-success p-button-sm" [disabled]="!newState" (click)="submitState()"></button>
          </div>
        </div>
      </div>
    </div>

    <div class="info-card" *ngIf="(history$ | async) as history">
      <div class="card-header"><i class="fa-solid fa-clock-rotate-left text-purple-600"></i><h3>Historial</h3></div>
      <div class="card-content">
        <div class="history-row" *ngFor="let h of history">
          <span class="history-transition">{{ h.from || '—' }} → {{ h.to }}</span>
          <span class="event-time">{{ h.occurredAt | timeElapsed }}</span>
          <span class="history-comment" *ngIf="h.comment">{{ h.comment }}</span>
        </div>
        <div class="empty-mini" *ngIf="history.length === 0">Sin cambios registrados.</div>
      </div>
    </div>

    <div class="info-card">
      <div class="card-header"><i class="fa-solid fa-comments text-green-600"></i><h3>Comentarios</h3></div>
      <div class="card-content">
        <div class="comment" *ngFor="let c of (comments$ | async)">
          <strong>{{ authorName(c.author) }}</strong>
          <span class="event-time">{{ c.createdAt | timeElapsed }}</span>
          <p>{{ c.content }}</p>
        </div>

        <div class="field field-flex">
          <textarea pInputTextarea [(ngModel)]="commentText" rows="3" placeholder="Escribe un comentario..."></textarea>
        </div>
        <div class="form-action">
          <button pButton type="button" label="Comentar" icon="fa-solid fa-paper-plane" class="p-button-success p-button-sm" [disabled]="!commentText.trim()" (click)="submitComment()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
<p-toast position="top-right"></p-toast>
